import React, { useState, useEffect } from "react";
import { View, ScrollView, KeyboardAvoidingView } from "react-native";

import { hasItems } from "../../../helpers/utils";

import Header from "../common/header";
import appStyles from "../../appStyles";
import ElementsList from "../elements/list/ElementsList";
import ElementsHelper from "../elements/ElementsHelper";
import Search from "../common/search-bar/Search";
import ElementsViewFabButton from "./ElementsViewFabButton";

const SORT_BY = "checked|is_core|is_major|name";

export default function EditReportElementsView({
  controller,
  selectedElementIds = [],
  goBack = () => {},
}) {
  const [selectedIds] = useState(new Set(selectedElementIds));
  const [itemsList, setItemsList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    _initElements(selectedElementIds);
  }, []);

  const _initElements = (elementIds) => {
    const allElements = ElementsHelper.filterResults(
      controller,
      {
        sortBy: SORT_BY,
      },
      elementIds,
    );

    setItemsList(allElements);
  };

  const saveSelectedElement = (element, isSelected) => {
    if (isSelected) {
      selectedIds.add(element.id);
    } else {
      selectedIds.delete(element.id);

      // 2021.09.22 If user deselects a major element deselect the children as well
      if (hasItems(element.children)) {
        element.children.forEach((cId) => {
          selectedIds.delete(cId);
          selectedIds.delete(`${cId}_misc`);
        });
        _initElements(Array.from(selectedIds));
      }
    }
    //setSelectedIds(selectedIds);
  };

  // ------------------------------------- SEARCH -------------------------------------
  const filterResults = (filters) => {
    setIsLoading(true);
    const elements = ElementsHelper.filterResults(controller, {
      ...filters,
      sortBy: SORT_BY,
    });

    setIsLoading(false);
    setItemsList(elements);
  };

  if (!hasItems(itemsList)) return null;

  return (
    <View style={appStyles.container}>
      <KeyboardAvoidingView style={appStyles.kbView} behavior="height">
        <Header
          title="Customize Report Elements"
          subTitle="Select Elements to add to report"
          hideAvatar
          goBack={() => goBack(Array.from(selectedIds))}
          controller={controller}
          isLoading={isLoading}
        />
        <ScrollView
          style={appStyles.scrollView}
          contentContainerStyle={appStyles.scrollViewContent}
        >
          <ElementsList
            showSelector
            controller={controller}
            elements={itemsList}
            onElementSelected={saveSelectedElement}
          />
        </ScrollView>

        <View style={[appStyles.footerOptions]}>
          <ElementsViewFabButton />

          <Search
            placeholder="Search Elements"
            controller={this.controller}
            filterResults={filterResults}
          />
        </View>
      </KeyboardAvoidingView>
    </View>
  );
}
